module.exports = __webpack_public_path__ + "static/img/2.97f0850.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/sp/2.png
// module id = rbQn
// module chunks = 0